import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import BuzonSugerenciasUsuario from "./usuario/BuzonSugerenciasUsuario";

export default function IntranetUsuarioSugerenciasPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialItem = location.state?.initialItem; // Future proofing

  return (
    <div className="intranet-red-theme">
      <BuzonSugerenciasUsuario
        onVolver={() => navigate("/menu/intranet/usuario")}
        initialSugerencia={initialItem}
      />
    </div>
  );
}
